import LoadingSpinner from '@/components/layouts/LoadingSpinner'

export default {
  components: {
    LoadingSpinner
  },
  data: () => ({
    isLoading: true,
    isSubmitable: true,
    isSaving: false,
    isDirty: false,
    form: {}
  }),
  computed: {
    project () { return this.$store.getters['project/getProject'](this.$route.params.id) }
  },
  methods: {
    flashValidationErrorToast (error = null) {
      if (error !== null) {
        let { graphQLErrors } = error
        this.$bvToast.toast(graphQLErrors[0].extensions.reason, {
          title: graphQLErrors[0].message,
          variant: 'danger',
          solid: true
        })
      } else {
        this.$root.$bvToast.toast('เกิดข้อผิดพลาดในการบันทึกข้อมูล ตรวจสอบการกรอกข้อมูลอีกครั้ง', {
          title: 'แจ้งเตือน',
          variant: 'danger',
          solid: true,
          noCloseButton: true
        })
      }
    },
    flashSaveSuccessToast () {
      this.$root.$bvToast.toast('บันทึกการเปลี่ยนแปลงสำเร็จ', {
        title: 'แจ้งเตือน',
        variant: 'success',
        solid: true,
        noCloseButton: true
      })
    },
    async discardEdit (to) {
      if (this.isDirty) {
        if (!await this.$bvModal.msgBoxConfirm(
          'มีการแก้ไขที่ยังไม่ถูกบันทึก หากยืนยันยกเลิกการแก้ไข ข้อมูลดังกล่าวจะสูญหาย',
          {
            title: 'ต้องการยกเลิกการแก้ไขโครงการนี้?',
            okTitle: 'ยกเลิกการแก้ไข',
            cancelTitle: 'ไม่',
            centered: true,
            okVariant: 'danger'
          }
        )) {
          return
        }
      }

      this.$router.push(to)
    }
  }
}
